import React from 'react';

const publicationCommittee = [
  {
    name: "Prof. Ashwani K Sharma",
    institute: "SET, CGC University, Mohali"
  },
  {
    name: "Prof. Rini Saxena",
    institute: "SET, CGC University, Mohali"
  }
  ];


const Publication = () => {
  return (
    <div>
      
      <div className='container mx-auto p-4 pt-20 sm:pt-4'>
        <div className="flex flex-wrap w-full relative flex-col flex-auto py-8 px-9">
          <h1 className="mb-2 text-[1.75rem] font-bold text-dark text-center text-4xl uppercase">
          Publication Committee
          </h1>
        </div>
        <div className="flex w-full text-2xl">
          <ul className="list-disc pl-5">
            {publicationCommittee.map((member, index) => (
              <li key={index} className="text-lg sm:text-2xl mb-4">
                {member.name}, {member.institute}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Publication;